import { useState } from 'react';
import { IconInfoCircleOutline } from '@iwoca/icons';
import { AlertBox, Card, Radio } from '@iwoca/orion';
import { ASSET_PREFIX } from 'utils/assets/assets';
import { RegistrationForm } from '../RegistrationForm/RegistrationForm';
import styles from './BeforeYouStart.module.css';

export const BeforeYouStart = () => {
  const [isRegistered, setIsRegistered] = useState<boolean | null>(null);

  return (
    <>
      <h2 className={styles.heading}>Before you start</h2>
      <Card className={styles.card}>
        <span className={styles.question}>
          Is your company or your parent company already working with iwoca
          (either directly or as an Appointed Representative)?
        </span>
        <div className={styles.radioOptions}>
          <Radio
            wrapperClassName={styles.radio}
            onChange={() => {
              setIsRegistered(true);
            }}
            checked={isRegistered === true}
            label="Yes"
          />
          <Radio
            wrapperClassName={styles.radio}
            onChange={() => {
              setIsRegistered(false);
            }}
            checked={isRegistered === false}
            label="No"
          />
        </div>
        {isRegistered && (
          <>
            <AlertBox className={styles.alert} variant="connect">
              <IconInfoCircleOutline
                className={styles.alertIcon}
                fontSize={20}
              />
              <p className={styles.alertText}>
                If your company is already partnered with us, please ask a
                colleague to share a referral link so you can get started right
                away. You don't need to register separately.
              </p>
            </AlertBox>
            <h3 className={styles.referralHeading}>
              Where your colleague can find the referral link
            </h3>
            <p className={styles.referralText}>
              In the introducer portal, click the profile icon in the top-right
              corner and select “Invite your colleagues” to get the referral
              link.
            </p>
            <div className={styles.imageContainer}>
              <img
                src={`${ASSET_PREFIX}/referralLinkInstruction.png`}
                className={styles.image}
                alt="Referral link instructions"
              />
            </div>
          </>
        )}
      </Card>
      {isRegistered === false && <RegistrationForm />}
    </>
  );
};
